import dedent from 'ts-dedent'
import {
  ColumnDataType,
  Provider,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent'

class OrderBy extends SelectSameSchemaWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.orderby',
        group: 'Data Preparation',
        title: 'Order by',
        description: `
      This component generates a new table containing the rows of an input one sorted
      according to the values in one of its columns, and an optional second column.

      `,
        starred: true
      },
      [
        {
          name: 'table',
          type: WorkflowComponentParamType.InputTable,
          title: 'Table to order'
        },
        {
          name: 'column',
          type: WorkflowComponentParamType.Column,
          title: 'Column to order by',
          dataType: [
            ColumnDataType.Number,
            ColumnDataType.String,
            ColumnDataType.Date,
            ColumnDataType.Time,
            ColumnDataType.Datetime,
            ColumnDataType.Timestamp
          ],
          parent: 'table'
        },
        {
          name: 'desc',
          type: WorkflowComponentParamType.Boolean,
          title: 'Use descending order',
          default: false
        },
        {
          name: 'columnb',
          type: WorkflowComponentParamType.Column,
          title: 'Optional secondary column to order by',
          parent: 'table',
          dataType: [
            ColumnDataType.Number,
            ColumnDataType.String,
            ColumnDataType.Date,
            ColumnDataType.Time,
            ColumnDataType.Datetime,
            ColumnDataType.Timestamp
          ],
          default: null,
          optional: true
        },
        {
          name: 'descb',
          type: WorkflowComponentParamType.Boolean,
          title: 'Use descending order in secondary column',
          default: false
        }
      ]
    )
    // In BQ, the output from this component cannot be optimized
    this.inputs = this.inputs.filter(
      (input) =>
        input.providers == undefined ||
        input.providers.includes(Provider.BigQuery)
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const columnb =
      params.columnb && params.columnb != params.column
        ? `, ${params.columnb} ${params.descb ? 'DESC' : 'ASC'}`
        : ''
    let select = ''
    if (connection.type === Provider.DatabricksRest) {
      select = dedent`
        SELECT /*+ REPARTITION(40) */
          *
        FROM
          ${connection.quoteName(params.table as string)}
        ORDER BY
          ${params.column} ${params.desc ? 'DESC' : 'ASC'} ${columnb}
        `
    } else {
      select = dedent`
        SELECT
          *
        FROM
          ${connection.quoteName(params.table as string)}
        ORDER BY
          ${params.column} ${params.desc ? 'DESC' : 'ASC'} ${columnb}
        `
    }
    return select
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    return '1.0.2'
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest
    ]
  }
}

export { OrderBy }
